// extracted by mini-css-extract-plugin
module.exports = {"deltamaxWrapper":"deltamax_deltamaxWrapper__ibxIm"};